import { Check, Loader2, X } from "lucide-react";
import { cn } from "@/lib/utils";

export interface ToolChipProps {
  label: string;
  status: "running" | "ok" | "error";
  summary?: string;
}

/**
 * Tool-activity chip: spinner + label while running ("Searching pieces…"),
 * check/✗ + summary once resolved ("Scheduled ✓"). Renders both live
 * stream events and persisted ToolCallRecord history.
 */
export function ToolChip({ label, status, summary }: ToolChipProps) {
  return (
    <div
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[12px]",
        status === "error"
          ? "border-destructive/40 text-destructive"
          : "border-border text-muted-foreground",
      )}
    >
      {status === "running" && <Loader2 size={12} className="animate-spin flex-shrink-0" />}
      {status === "ok" && <Check size={12} className="flex-shrink-0 text-green-500" />}
      {status === "error" && <X size={12} className="flex-shrink-0" />}
      <span className="truncate max-w-[260px]">
        {status === "running" ? label : (summary ?? label)}
      </span>
    </div>
  );
}
